const donationForm = (() => {
    const activateOtherChoice = (radio, otherInput, shouldFocus = true) => {
        if (!radio || !otherInput) {
            return;
        }

        if (!radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (typeof window.gformToggleRadioOther === 'function') {
            window.gformToggleRadioOther(radio);
        }

        otherInput.disabled = false;

        if (shouldFocus) {
            otherInput.focus();
        }
    };

    const sanitizeAmountValue = (value) => {
        const cleaned = String(value).replace(/[^0-9.]/g, '');
        const parts = cleaned.split('.');

        if (parts.length === 1) {
            return parts[0];
        }

        return `${parts.shift()}.${parts.join('').slice(0, 2)}`;
    };

    const initOtherAmountFields = (scope = document) => {
        scope.querySelectorAll('.donation-form .gchoice_other_control').forEach((otherInput) => {
            if (otherInput.dataset.donationOtherInit === '1') {
                return;
            }

            otherInput.dataset.donationOtherInit = '1';

            const gchoice = otherInput.closest('.gchoice');
            const radio = gchoice?.querySelector('.gfield-choice-input');

            if (!gchoice || !radio) {
                return;
            }

            otherInput.setAttribute('inputmode', 'decimal');
            otherInput.setAttribute('pattern', '[0-9]*[.]?[0-9]*');
            otherInput.setAttribute('autocomplete', 'off');

            if (!otherInput.getAttribute('placeholder')) {
                otherInput.setAttribute('placeholder', 'Enter amount');
            }

            // Disabled inputs don't receive clicks — handle on the parent instead.
            gchoice.addEventListener('pointerdown', (event) => {
                if (event.button !== 0) {
                    return;
                }

                if (!radio.checked || otherInput.disabled) {
                    activateOtherChoice(radio, otherInput, true);
                }
            });

            otherInput.addEventListener('focus', () => {
                activateOtherChoice(radio, otherInput, false);
            });

            otherInput.addEventListener('beforeinput', (event) => {
                if (event.inputType?.startsWith('delete') || !event.data) {
                    return;
                }

                if (!/^[0-9.]+$/.test(event.data)) {
                    event.preventDefault();
                }
            });

            otherInput.addEventListener('input', () => {
                activateOtherChoice(radio, otherInput, false);

                const sanitized = sanitizeAmountValue(otherInput.value);

                if (otherInput.value !== sanitized) {
                    otherInput.value = sanitized;
                }
            });

            otherInput.addEventListener('paste', (event) => {
                event.preventDefault();

                const pasted = event.clipboardData?.getData('text') || '';
                const sanitized = sanitizeAmountValue(pasted);

                otherInput.value = sanitized;
                activateOtherChoice(radio, otherInput, false);
                otherInput.dispatchEvent(new Event('input', { bubbles: true }));
            });
        });
    };

    const initDefaultFrequency = (scope = document) => {
        scope.querySelectorAll('.donation-form form').forEach((form) => {
            const frequencyField = form.querySelector('.gfield--type-radio');

            if (!frequencyField) {
                return;
            }

            const radios = frequencyField.querySelectorAll('.gfield-choice-input[type="radio"]');
            const hasSelection = Array.from(radios).some((radio) => radio.checked);

            if (hasSelection || !radios.length) {
                return;
            }

            const firstRadio = radios[0];
            firstRadio.checked = true;
            firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
        });
    };

    const initCurrencySelector = (scope = document) => {
        scope.querySelectorAll('.donation-form [data-donation-currency-selector]').forEach((selector) => {
            if (selector.dataset.donationCurrencyInit === '1') {
                return;
            }

            selector.dataset.donationCurrencyInit = '1';

            const select = selector.querySelector('[data-donation-currency-select]');
            const items = selector.querySelectorAll('[data-currency]');

            if (!select || !items.length) {
                return;
            }

            const showCurrency = (slug) => {
                items.forEach((item) => {
                    item.hidden = item.dataset.currency !== slug;
                });
            };

            select.addEventListener('change', () => {
                showCurrency(select.value);
            });
        });
    };

    const ready = () => {
        initDefaultFrequency();
        initOtherAmountFields();
        initCurrencySelector();

        document.addEventListener('gform_post_render', () => {
            initDefaultFrequency();
            initOtherAmountFields();
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ready);
    } else {
        ready();
    }

    return {
        initDefaultFrequency,
        initOtherAmountFields,
        initCurrencySelector,
    };
})();
